var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "centerbox" },
      [
        _c("headbox", { attrs: { title: "业务说明", bgColor: "#fff" } }),
        _c("img", {
          attrs: { src: require("@/assets/images/yewyshuoming.png"), alt: "" }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }